import React from "react";
import {useParams} from 'react-router-dom';
import productsContent from "../productsContent";
import ProductList from "../Components/ProductList";



function ProductPage() {
    let params = useParams();
    const name = params.name;
    const product = productsContent.find(prod => prod.name === name);

    if (!product) return <h3>Product not found!</h3>;
    
    const productsInCategory = productsContent.filter( prod => (prod.category === product.category) && (prod.name !== name))
    return(
        <>
            <body id="productBody">
                <div className="container">
                    <div className="innerContainer">
                        <div className="innerProductContainer">
                            <h1 className = "header">{product.name}{product.model}</h1>
                            <h2 className = "header">$ {product.price}</h2>
                        </div>
                        <p className="p">{product.description}</p>
                    </div>
                    <hr></hr>
                    <div className="innerContainer">
                        <h1 className="header">Other Products in {product.category} category</h1>
                        <ProductList products={productsInCategory} />
                    </div>
                </div>
            </body>
        </>
    );
}

export default ProductPage;